<div class="payment_plans">
    <div style="text-align: center;">
        <div class="social_media_button">
            <button (click)="monthly()" class="monthly"
                [ngStyle]="{'background': ismonthly ? 'white' : '#ff600f', 'color': ismonthly ? 'black': 'white', 'border': ismonthly ? '2px solid #ff600f' : 'none'}">
                Monthly
            </button>
            <button (click)="annually()" class="monthly"
                [ngStyle]="{'background': isannually ? 'white' : '#ff600f', 'color': isannually ? 'black': 'white', 'border': isannually ? '2px solid #ff600f' : 'none'}">
                Quarterly
            </button>
        </div>
    </div>
    <div class="social_media_slider" *ngIf="ismonthly">
        <div class="social_media_sliders">
            <div class="social_media_card_1">
                <div class="image_icon">
                    <img src="\assets\basic.gif" loading="lazy" alt="basic"
                        style="height:40px;margin: 7px;display: inline-block;vertical-align: top;">
                </div>
                <div class="social_media_header">IGNITE</div>
                <div [@flipAnimation]="currentState" class="social_media_ammount" style="color: #53affa;">₹&nbsp;<span
                        class="social_media_discount_ammount">4999</span>2999
                </div>
                <div class="social_media_plan_month_text" style="color: #53affa;">/ Month</div>
                <div class="social_media_details ">
                    <div class="social_media_plan_detail_item block_a"><img src="\assets\1.png" alt="basic"
                            style="width:14px;height:14px;margin-right: 10px;">14 POSTS (alternate day)</div>
                    <div class="social_media_plan_detail_item block_a"><img src="\assets\1.png" alt="basic"
                            style="width:14px;height:14px;margin-right: 10px;">2 REELS</div>
                    <div class="social_media_plan_detail_item block_a"><img src="\assets\1.png" alt="basic"
                            style="width:14px;height:14px;margin-right: 10px;">2 CAROUSELS per month</div>
                    <div class="social_media_plan_detail_item block_a"><img src="\assets\1.png" alt="basic"
                            style="width:14px;height:14px;margin-right: 10px;">Basic customer support</div>
                </div>
                <div class="contact_us_button" routerLink="/Login" style="background-color:#53affa;color: white;">
                    Get Started >
                    <div class="plan_curve"></div>
                </div>
            </div>
            <div class="most_popular">
                <div class="social_media_most_popular_text">MOST POPULAR</div>
                <div class="social_media_card_2">
                    <div class="image_icon"><img src="\assets\rocketing.gif" loading="lazy" alt="popular"
                            style="height:40px; margin: 7px; display: inline-block; vertical-align: top;">
                    </div>
                    <div class="social_media_header">BOOST</div>
                    <div [@flipAnimation]="currentState" class="social_media_ammount"style="color: #ff600f;">₹&nbsp;<span
                            class="social_media_discount_ammount">5999</span>3499
                    </div>
                    <div class="social_media_plan_month_text" style="color: #ff600f;">/ Month</div>
                    <div class="social_media_details">
                        <div class="social_media_plan_detail_item block_b"><img src="\assets\2.png" alt="popular"
                                style="width:14px;height:14px;margin-right: 10px;">22 POSTS (daily)</div>
                        <div class="social_media_plan_detail_item block_b"><img src="\assets\2.png" alt="popular"
                                style="width:14px;height:14px;margin-right: 10px;">4 REELS (1 per
                            week)</div>
                        <div class="social_media_plan_detail_item block_b"><img src="\assets\2.png" alt="popular"
                                style="width:14px;height:14px;margin-right: 10px;">4 CAROUSELS (1 per
                            week)</div>
                        <div class="social_media_plan_detail_item block_b"><img src="\assets\2.png" alt="popular"
                                style="width:14px;height:14px;margin-right: 10px;">In trend content</div>
                        <!-- <div class="social_media_plan_detail_item block_b"><img src="\assets\2.png" alt="popular"
                                style="width:14px;height:14px;margin-right: 10px;">Dedicated account
                            manager</div> -->
                    </div>
                    <div class="contact_us_button" routerLink="/Login" style="background-color:#ff600f;color: white;">Get Started >
                        <div class="plan_curve"></div>
                    </div>
                </div>
            </div>

            <div class="social_media_card_3">
                <div class="image_icon"><img src="\assets\dimond.gif" loading="lazy" alt="viral"
                        style="height:40px; margin: 7px; display: inline-block; vertical-align: top;"></div>
                <div class="social_media_header">VIRAL</div>
                <div [@flipAnimation]="currentState" class="social_media_ammount" style="color: #9053cc;">₹&nbsp;<span
                        class="social_media_discount_ammount">6999</span>3999
                </div>
                <div class="social_media_plan_month_text" style="color: #9053cc;">/ Month</div>
                <div class="social_media_details">

                    <div class="social_media_plan_detail_item block_c"><img src="\assets\3.png" alt="viral"
                            style="width:14px;height:14px;margin-right: 10px;">22 POSTS (daily)</div>
                    <div class="social_media_plan_detail_item block_c"><img src="\assets\3.png" alt="viral"
                            style="width:14px;height:14px;margin-right: 10px;">4 REELS (1 per
                        week)</div>
                    <div class="social_media_plan_detail_item   block_c"><img src="\assets\3.png" alt="viral"
                            style="width:14px;height:14px;margin-right: 10px;">4 CAROUSELS (1 per
                        week)</div>
                    <div class="social_media_plan_detail_item block_c"><img src="\assets\3.png" alt="viral"
                            style="width:14px;height:14px;margin-right: 10px;">In trend content</div>

                    <!-- <div class="social_media_plan_detail_item block_c"><img src="\assets\3.png" alt="viral"
                            style="width:14px;height:14px;margin-right: 10px;">Dedicated account
                        manager</div> -->
                    <!-- <div><img src="\assets\3.png" alt=""
                            style="width:14px;height:14px;margin-right: 10px;">Trendy customised Song / Anthem</div> -->
                    <div  class="social_media_plan_detail_item block_c" style="display: flex; align-items: center; gap: 10px;">
                                <img src="\assets\3.png" alt="viral" style="width: 14px; height: 14px;">
                                <div>Trendy customised Song / Anthem</div>
                    </div>
                              
                </div>
                <div class="contact_us_button" routerLink="/Login" style="background-color:#9053cc;color: white;">Get Started >
                    <div class="plan_curve"></div>
                </div>
            </div>
        </div>

        <div class="dots">
            <span class="dot" [class.active]="currentSlide === 0" (click)="setSlide(0)"></span>
            <span class="dot" [class.active]="currentSlide === 1" (click)="setSlide(1)"></span>
            <span class="dot" [class.active]="currentSlide === 2" (click)="setSlide(2)"></span>
        </div>
    </div>

    <div class="social_media_slider" *ngIf="!ismonthly">
        <div class="social_media_sliders" (scroll)="onScroll($event)">
            <div class="social_media_card_1">
                <div class="image_icon"><img src="\assets\basic.gif" loading="lazy"  alt="basic"
                        style="height:40px; margin: 7px; display: inline-block; vertical-align: top;"></div>
                <div class="social_media_header">IGNITE</div>
                <div [@flipAnimation]="currentState" class="social_media_ammount" style="color: #53affa;">₹&nbsp;<span
                        class="social_media_discount_ammount">14997</span>7999
                </div>
                <div class="social_media_plan_month_text" style="color: #53affa;">/Quaterly</div>
                <div class="social_media_details">
                    <div class="social_media_plan_detail_item block_a"><img src="\assets\1.png" alt="basic"
                            style="width:14px;height:14px;margin-right: 10px;">14 POSTS (alternate day)</div>
                    <div class="social_media_plan_detail_item block_a"><img src="\assets\1.png" alt="basic"
                            style="width:14px;height:14px;margin-right: 10px;">2 REELS</div>
                    <div class="social_media_plan_detail_item block_a"><img src="\assets\1.png" alt="basic"
                            style="width:14px;height:14px;margin-right: 10px;">2 CAROUSELS per month</div>
                    <div class="social_media_plan_detail_item block_a"><img src="\assets\1.png" alt="basic"
                            style="width:14px;height:14px;margin-right: 10px;">Basic customer support</div>
                </div>
                <div class="contact_us_button" routerLink="/Login" style="background-color: #53affa;">Get Started >
                    <div class="plan_curve"></div>
                </div>
            </div>
            <div class="most_popular" style="margin-bottom: 10px; ">
                <div class="social_media_most_popular_text">MOST POPULAR</div>
                <div class="social_media_card_2">
                    <div class="image_icon"><img src="\assets\rocketing.gif" loading="lazy"  alt="popular"
                            style="height:40px; margin: 7px; display: inline-block; vertical-align: top;">
                    </div>
                    <div class="social_media_header">BOOST</div>
                    <div [@flipAnimation]="currentState" class="social_media_ammount"style="color: #ff600f;">₹&nbsp;<span
                            class="social_media_discount_ammount">17997</span>9499</div>
                    <div class="social_media_plan_month_text" style="color: #ff600f;">/ Quaterly</div>
                    <div class="social_media_details">
                        <div class="social_media_plan_detail_item block_b"><img src="\assets\2.png" alt="popular"
                                style="width:14px;height:14px;margin-right: 10px;">22 POSTS (daily)</div>
                        <div class="social_media_plan_detail_item block_b"><img src="\assets\2.png" alt="popular"
                                style="width:14px;height:14px;margin-right: 10px;">4 REELS (1 per
                            week)</div>
                        <div class="social_media_plan_detail_item block_b"><img src="\assets\2.png" alt="popular"
                                style="width:14px;height:14px;margin-right: 10px;">4 CAROUSELS (1 per
                            week)</div>
                        <div class="social_media_plan_detail_item block_b"><img src="\assets\2.png" alt="popular"
                                style="width:14px;height:14px;margin-right: 10px;">In trend content</div>
                        <!-- <div class="social_media_plan_detail_item block_b"><img src="\assets\2.png" alt="popular"
                                style="width:14px;height:14px;margin-right: 10px;">Dedicated account
                            manager</div> -->
                    </div>
                    <div class="contact_us_button" routerLink="/Login" style="background-color: #ff600f;">Get Started >
                        <div class="plan_curve"></div>
                    </div>
                </div>
            </div>
            <div class="social_media_card_3">
                <div class="image_icon"><img src="\assets\dimond.gif" loading="lazy" alt="viral"
                        style="height:40px; margin: 7px; display: inline-block; vertical-align: top;"></div>
                <div class="social_media_header">VIRAL</div>
                <div [@flipAnimation]="currentState" class="social_media_ammount"style="color: #9053cc;">₹&nbsp;<span
                        class="social_media_discount_ammount">20997</span>10499
                </div>
                <div class="social_media_plan_month_text" style="color: #9053cc;">/ Quaterly</div>
                <div class="social_media_details">
                    <div class="social_media_plan_detail_item block_c"><img src="\assets\3.png" alt="viral"
                            style="width:14px;height:14px;margin-right: 10px;">22 POSTS (daily)</div>
                    <div class="social_media_plan_detail_item block_c"><img src="\assets\3.png" alt="viral"
                            style="width:14px;height:14px;margin-right: 10px;">4 REELS (1 per
                        week)</div>
                    <div class="social_media_plan_detail_item block_c"><img src="\assets\3.png" alt="viral"
                            style="width:14px;height:14px;margin-right: 10px;">4 CAROUSELS (1 per
                        week)</div>
                    <div class="social_media_plan_detail_item block_c"><img src="\assets\3.png" alt="viral"
                            style="width:14px;height:14px;margin-right: 10px;">In trend content</div>

                    <!-- <div class="social_media_plan_detail_item block_c"><img src="\assets\3.png" alt="viral"
                            style="width:14px;height:14px;margin-right: 10px;">Dedicated account
                        manager</div> -->
                    <div class="social_media_plan_detail_item block_c"><img src="\assets\3.png" alt="viral"
                            style="width:14px;height:14px;margin-right: 10px;">Trendy customised song /Anthem</div>
                </div>
                <div class="contact_us_button" (click)="GetStarted()"style="background-color: #9053cc;">Get Started >
                    <div class="plan_curve"></div>
                </div>
            </div>
        </div>
        <div class="dots">
            <span class="dot" [class.active]="currentSlide === 0" (click)="setSlide(0)"></span>
            <span class="dot" [class.active]="currentSlide === 1" (click)="setSlide(1)"></span>
            <span class="dot" [class.active]="currentSlide === 2" (click)="setSlide(2)"></span>
        </div>
    </div>
</div>

<div style="background-color: white;text-align: center;"><h3 style="margin: 0px;padding: 10px 0px 20px 0px;font-family: Montserrat;">Start 7-day Free Trail</h3></div>